module.exports = __webpack_public_path__ + "img/work3.7e63f2f3.png";